import React from 'react';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import i18n from 'i18n-js';
import Title from 'components/Title';
import Layout from 'components/Layout';
import Comments from 'components/Comments';
import Logs from 'components/Logs';

import { Map, Details } from 'components/Locations';
import Can from 'components/Can';
import { useParams } from 'react-router-dom';
import DocumentsWidget from 'components/Documents/Widget';

const LocationDetails = () => {
  const { id } = useParams();

  return (
    <Layout title={i18n.t('locations.details_title')}>
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <Grid container spacing={2} direction="row" justifyContent="space-between">
              <Grid>
                <Title data-cy="title" title={i18n.t('locations.details_title')} />
              </Grid>
            </Grid>
          </Grid>
          <Grid size={12}>
            <Grid container spacing={2}>
              <Grid size={{ sm: 12, md: 6, lg: 4 }}>
                <Grid container spacing={2}>
                  <Grid size={12}>
                    <Details id={id} />
                  </Grid>
                  <Can I="read" a="document">
                    <Grid size={12}>
                      <DocumentsWidget type="Location" id={parseInt(id)} />
                    </Grid>
                  </Can>
                </Grid>
              </Grid>
              <Grid size={{ sm: 12, md: 6, lg: 8 }}>
                <Grid container spacing={2}>
                  <Grid size={12}>
                    <Map id={parseInt(id)} />
                  </Grid>
                  <Can I="read" on="event_log">
                    <Grid size={6}>
                      <Logs targetId={parseInt(id)} targetType="Location" title="Location logs" />
                    </Grid>
                  </Can>
                  <Grid size={6}>
                    <Comments type="location" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default LocationDetails;
